export default {"src":"/_next/static/media/phone-animation.7842a773.svg","height":460,"width":720};